import React from 'react';
import useResizeObserver from 'use-resize-observer';

export const useSyncDimensions = (containerRef?: React.RefObject<HTMLElement | null>) => {
  const { height } = useResizeObserver<HTMLElement>({
    ref: containerRef as React.RefObject<HTMLElement>,
    box: 'border-box',
  });
  return height;
};
